import request from '@/utils/request'

// 查询租户列表分页
export function pageTenant(query) {
  return request({
    url: '/system/tenant/page/agent',
    method: 'get',
    params: query,
  })
}
// 查询租户列表
export function listTenant(query) {
  return request({
    url: '/system/tenant/page',
    method: 'get',
    params: query,
  })
}

// 检验厂商-经销商是否存在
export function codeTenant(query) {
  return request({
    url: '/system/tenant/code',
    method: 'get',
    params: query,
  })
}
// 查询租户详细
export function getTenant(TenantId) {
  return request({
    url: '/system/tenant/detail?id=' + TenantId,
    method: 'get',
  })
}

// 新增代理商
export function addTenant(data) {
  return request({
    url: '/system/tenant/add01',
    method: 'post',
    data: data,
  })
}
// 新增厂商
export function addEnterprise(data) {
  return request({
    url: '/system/tenant/add',
    method: 'post',
    data: data,
  })
}
// 批量导入
export function importTenant(data) {
  return request({
    url: '/system/tenant/import',
    method: 'post',
    data: data,
  })
}
// 批量导入验收员和水工
export function importData(data) {
  return request({
    url: '/system/user/importData',
    method: 'post',
    data: data,
  })
}
// 批量导入设备
export function importDev(data) {
  return request({
    url: '/fix/dev/import',
    method: 'post',
    data: data,
  })
}
// 绑定代理商
export function tenantBd(data) {
  return request({
    url: '/system/tenant/bd01',
    method: 'post',
    data: data,
  })
}
// 绑定企业品牌
export function enterpriseBd(data) {
  return request({
    url: '/system/tenant/bd01',
    method: 'post',
    data: data,
  })
}
// 修改租户
export function updateTenant(data) {
  return request({
    url: '/system/tenant/edit',
    method: 'post',
    data: data,
  })
}
// 绑定代理商
export function bd01Tenant(data) {
  return request({
    url: '/system/tenant/bd01',
    method: 'post',
    data: data,
  })
}
// 冻结租户
export function frozenTenant(data) {
  return request({
    url: '/system/tenant/frozen',
    method: 'post',
    data: data,
  })
}
// 解绑
export function relationship(data) {
  return request({
    url: '/system/tenant/relationship/del',
    method: 'post',
    data: data,
  })
}

export function listAgent(query) {
  return request({
    url: '/system/tenant/page/agent',
    method: 'get',
    params: query,
  })
}
